import { Injectable } from '@angular/core';
import { DateRange } from '@com-delta-omnichannel/mach-core-js';
import { StaysWidget } from '../../stays-widget/models/stays-widget.interfaces';

@Injectable({
  providedIn: 'root'
})
export class DateDisplayFormatterService {
  updateDisplayWithDates(
    displaySpan: HTMLElement,
    dates: DateRange,
    content: StaysWidget
  ): void {
    const { startDate, endDate, ariaLabel } = this.buildDateDisplayStrings(
      dates,
      content
    );
    displaySpan.textContent = `${startDate} - ${endDate}`;
    displaySpan.setAttribute('aria-label', ariaLabel);
    this.applyDateDisplayStyles(displaySpan);
  }

  private buildDateDisplayStrings(
    dates: DateRange,
    content: StaysWidget
  ): { startDate: string; endDate: string; ariaLabel: string } {
    const startFormatted = content.labels.startDate;
    const endFormatted = content.labels.endDate;
    const startDate = this.getFormattedOrDefault(dates.start, startFormatted);
    const endDate = this.getFormattedOrDefault(dates.end, endFormatted);
    const ariaStartDate = this.getAriaDate(
      dates.start,
      startFormatted,
      startFormatted
    );
    const ariaEndDate = this.getAriaDate(dates.end, endFormatted, endFormatted);
    const ariaLabel = `${content.labels.findButton} ${ariaStartDate} - ${ariaEndDate} date`;
    return { startDate, endDate, ariaLabel };
  }

  private getFormattedOrDefault(
    date: Date | null,
    defaultValue: string
  ): string {
    return date ? this.formatDate(date) : defaultValue;
  }

  private getAriaDate(
    date: Date | null,
    label: string,
    defaultValue: string
  ): string {
    return date ? label + ' ' + this.formatDate(date) : defaultValue;
  }

  private applyDateDisplayStyles(displaySpan: HTMLElement): void {
    displaySpan.classList.add('text-body-copy', 'text-label-md-medium');
    displaySpan.classList.remove(
      'text-subtle',
      'whitespace-nowrap',
      'laptop:max-w-[126px]',
      'laptop:overflow-hidden',
      'laptop:text-ellipsis',
      'ultrawide:max-w-none'
    );
  }

  private formatDate(date: Date): string {
    if (date) {
      const options: Intl.DateTimeFormatOptions = {
        month: 'short',
        day: 'numeric'
      };
      return date.toLocaleDateString('en-US', options);
    }
    return '';
  }
}
